import classnames from 'classnames';

const namespace = 'text-alignment';

const textAlignment = (alignment, className) => classnames({ [`${namespace}--${alignment}`]: alignment }, className);

export default textAlignment;
